import { NordDarkTheme } from "../.internal/themes/NordDarkTheme";
export default NordDarkTheme;
